import script from "./globalSearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./globalSearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./globalSearchInput.vue?vue&type=style&index=0&id=3dfec20f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfec20f"]])

export default __exports__